import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListResponse, ListRow } from '@/shared/ui/list/types';
import { fetchStatCount } from './api';
import { dateRangeFilters, placeFilters } from './filters';

const TOTAL_KEY = 'total';

interface CountRow extends ListRow {
  date: string;
  s0?: number | string;
  s1?: number | string;
  s2?: number | string;
  s3?: number | string;
  s4?: number | string;
  s5?: number | string;
  s6?: number | string;
}

/** `result` is an object keyed by date (plus `total`); each value holds the per-status counters. */
const toRows = ({ result }: ListResponse): CountRow[] =>
  Object.entries((result ?? {}) as Record<string, Omit<CountRow, 'date'>>).map(([date, counters]) => ({
    ...counters,
    date,
  }));

const config: ListPageConfig<CountRow> = {
  queryKey: 'stat-count',
  title: 'Статистика',
  boxTitle: 'Статистика по заявкам',
  errorText: 'Ошибка загрузки статистики',
  fetchList: fetchStatCount,
  rows: toRows,
  filters: [...dateRangeFilters(true), ...placeFilters(true)],
  columns: [
    { header: 'Дата', render: ({ date }) => (date === TOTAL_KEY ? 'Итого' : date) },
    { header: 'Заявки', render: (row) => row.s0 },
    { header: 'Визит в СТО', render: (row) => row.s1 },
    { header: 'В работе', render: (row) => row.s2 },
    { header: 'Ремонт завершен', render: (row) => row.s3 },
    { header: 'Отмодерировано', render: (row) => row.s6 },
    { header: 'Закрыто', render: (row) => row.s5 },
    { header: 'Отменен', render: (row) => row.s4 },
  ],
};

export const StatCountPage = () => <GenericListPage config={config} />;
